import { useContext } from 'react';

import { ensureDefined } from '@e-socna/utils';

import { DocumentResolverContext } from '..';

export const useDocumentResolverContext = () =>
  ensureDefined({ context: useContext(DocumentResolverContext) }).context;
